import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import ImportFile from "../../components/fileProcessing/importFile";
import ImportFileHistoricalList from "../../components/fileProcessing/importFileHistoricalList";

import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const Imports = props => (
  <ProtectedRoute>
    <main>
    <Helmet title="Import" />
    <Layout>
      <Routes>
        <Route path="/" element={<ImportFileHistoricalList />} />
        <Route path="new" element={<ImportFile />} />
      </Routes>
    </Layout>
    </main>
  </ProtectedRoute>
);

export default Imports;
